const layers = [
  {
    type: 'overlayers',
    name: 'Sobreposições',
    visible: true,
    layers: [
      {
        id: 100,
        name: 'Índice de Conformidade de Enquadramento (ICE)',
        url: 'https://produtos.simepar.br/geoserver/db/wms?',
        url_params: {
          LAYERS: 'db:ice_tecpar_colunas',
          SRS: 'EPSG:4326',
          TRANSPARENT: true,
        },
        layer_class: 'ol.layer.Tile',
        layer_type: 'ol.source.TileWMS',
        property_params: {
          opacity: 1.0,
          visible: false,
          zindex: 3,
        },

        icon_params: {
          class: '$iceMap',
          background_color: '#F2C94C',
        },

        tooltip_params: {
          KEYS: [
            '{"key": "locationname", "label": "SIA", "icon_label": "circle"}',
            '{"key": "total_classe", "label": "Total", "icon_label": "circle"}',
            '{"key": "fisicoquimico_classe", "label": "Físico-químico", "icon_label": "circle"}',
            '{"key": "metais_classe", "label": "Metais", "icon_label": "circle"}',
            '{"key": "toxico_classe", "label": "Tóxicos", "icon_label": "circle"}',
            '{"key": "ptotecpar", "label": "Tecpar", "icon_label": "circle"}',
          ],
          FORMAT:
            '{0} <br>Pastagem: {1}<br>Agricultura: {2}<br>Silvicultura: {3}',
        },
        has_submenu: true,
        caption_html: {
          alwaysVisible: false,
          vertical: false,
          custom: true,
          groupItems: [
            {
              items: [
                { text: 'Ótimo', color: '#2F80ED', style: 'circle' },
                { text: 'Ruim', color: '#F2994A', style: 'circle' },
              ],
            },
            {
              items: [
                { text: 'Bom', color: '#219653', style: 'circle' },
                { text: 'Péssimo', color: '#EB5757', style: 'circle' },
              ],
            },
            {
              items: [
                { text: 'Regular', color: '#F2C94C', style: 'circle' },
                { text: 'Sem dados', color: '#D9D9D9', style: 'circle' },
              ],
            },
          ],
        },
      },
      {
        id: 733,
        name: 'Ponto de captação e bacia de manancial',
        url: 'https://produtos.simepar.br/geobarragem/bd/wms?',
        url_params: {
          LAYERS: 'bd:group_sia',
          STYLES: 'pgw-group_sia',
          SRS: 'EPSG:4326',
          VIEWPARAMS: 'locationid:1162',
          ENV: 'circle_fill_color:3eca8f;polygon_fill_color:b1ebce;polygon_fill_opacity:0.8;polygon_stroke_color:58d09a',
        },
        layer_class: 'ol.layer.Tile',
        layer_type: 'ol.source.TileWMS',
        property_params: {
          opacity: 0.9,
          visible: true,
          zindex: 0,
        },
        hide_on_menu: true,
      },
      {
        id: 734,
        name: 'Outorgas de Efluentes emitidas pelo IAT',
        url: 'https://produtos.simepar.br/geosimepar/sanepar/wms?',
        url_params: {
          LAYERS: 'sanepar:outorga_efluentes_sia',
          SRS: 'EPSG:4326',
        },
        layer_class: 'ol.layer.Tile',
        layer_type: 'ol.source.TileWMS',
        property_params: {
          opacity: 1.0,
          visible: false,
          zindex: 1,
        },
        tooltip_params: {
          KEYS: [
            '{"key": "CONDICAO", "label": "CONDIÇÃO", "icon_label": "circle"}',
            '{"key": "USO", "label": "USO", "icon_label": "circle"}',
            '{"key": "ATIVIDADE", "label": "ATIVIDADE", "icon_label": "circle"}',
            '{"key": "MODALIDADE", "label": "MODALIDADE", "icon_label": "circle"}',
            '{"key": "OEFSIA", "label": "SIA", "icon_label": "circle"}',
          ],
          FORMAT:
            'CONDICAO: {0}<br>USO: {1}<br>ATIVIDADE NOME: {2}<br>MODALIDADE: {3}',
        },
        icon_params: {
          class: '$effluentsGranting',
          background_color: '#9B51E0',
        },
      },
      {
        id: 1749,
        name: 'Uso do solo',
        url: 'https://produtos.simepar.br/geoserver/sanepar/wms?',
        url_params: {
          LAYERS: 'sanepar:usodosolo_latest',
          TRANSPARENT: true,
          SRS: 'EPSG:4326',
          Format: 'image/png',
        },
        layer_class: 'ol.layer.Tile',
        layer_type: 'ol.source.TileWMS',
        property_params: {
          opacity: 1.0,
          visible: false,
          zindex: 0,
        },
        icon_params: {
          class: '$useSoil',
          background_color: '#27AE60',
        },
        caption_html: {
          alwaysVisible: false,
          vertical: false,
          custom: true,
          groupCustom: [
            { text: 'Floresta', color: '#497000', style: 'circle' },
            { text: 'Silvicultura', color: '#A5F900', style: 'circle' },
            { text: 'Água', color: '#273FB6', style: 'circle' },
            { text: 'Pastagem', color: '#FEFD00', style: 'circle' },
            { text: 'Agricultura', color: '#EB5757', style: 'circle' },
            { text: 'Campo Alagado', color: '#43704C', style: 'circle' },
            {
              text: 'Agricultura Semi-perene',
              color: '#CE9E00',
              style: 'circle',
            },
            { text: 'Mangue', color: '#C7FA72', style: 'circle' },
            { text: 'Área Urbanizada', color: '#8C2202', style: 'circle' },
          ],
          groupItems: [
            {
              items: [
                { text: 'Floresta', color: '#497000', style: 'circle' },
                { text: 'Silvicultura', color: '#A5F900', style: 'circle' },
                { text: 'Água', color: '#273FB6', style: 'circle' },
              ],
            },
            {
              items: [
                { text: 'Pastagem', color: '#FEFD00', style: 'circle' },
                { text: 'Agricultura', color: '#EB5757', style: 'circle' },
                { text: 'Campo Alagado', color: '#43704C', style: 'circle' },
              ],
            },
            {
              items: [
                {
                  text: 'Agricultura Semi-perene',
                  color: '#CE9E00',
                  style: 'circle',
                },
                { text: 'Mangue', color: '#C7FA72', style: 'circle' },
                { text: 'Área Urbanizada', color: '#8C2202', style: 'circle' },
              ],
            },
          ],
        },
      },
      {
        id: 739,
        name: 'Pontos de captação',
        url: 'https://produtos.simepar.br/geosimepar/forecastdev/wms?',
        url_params: {
          LAYERS: 'forecastdev:pontocaptacao',
          STYLES: 'pgw-sia-catchment_point',
          ENV: 'circle_fill_color:7AC1FF',
        },
        layer_class: 'ol.layer.Tile',
        layer_type: 'ol.source.TileWMS',
        tooltip_params: {
          KEYS: [
            '{"key": "cptsia,citname,sistema,cptnome", "label_title": "SIA"}',
          ],
          FORMAT: 'SIA {0} - {1} - {2} - {3}',
        },
        event_params: {
          type: 'click',
        },
        property_params: {
          opacity: 0.9,
          visible: false,
          zindex: 2,
        },
        icon_params: {
          class: 'icon-infohidro-pontos-captacao',
          background_color: '#7AC1FF',
        },
      },
      {
        "id": 622,
        "name": "Bacias de mananciais",
        "url": "https://produtos.simepar.br/geosimepar/forecastdev/wms?",
        "url_params": {
          "LAYERS": "forecastdev:mananciais_sanepar",
          "STYLES": "pgw_polygon_env",
          "ENV": "stroke_color:0583F2;fill_color:FFF;stroke_width:1;fill_opacity:0.15"
        },
        "layer_class": "ol.layer.Tile",
        "layer_type": "ol.source.TileWMS",
        "tooltip_params": {
          "KEYS": [
            '{"key": "sbsname", "label_title": ""}',
            '{"key": "sbsobs", "property_child": "Q95", "label": "Q95", "suffix": ""}',
            '{"key": "sbsobs", "property_child": "area", "label": "Área", "suffix": "", "decimal_number": 1}',
          ],
          "FORMAT": "{0}<br>{1}<br>{2}",
          "icon_params":{
            "class": "icon-infohidro-bacia",
            "background_color": "#0071B0"
          },
        },
        "event_params": {
          "type": "click",
        },
        "property_params": {
          "opacity": 1,
          "visible": false,
          "zindex": 1,
          "highlightOnHoverFeature": {
            "fillColor": 'rgba(101, 156, 213, 0.5)',
            "strokeColor": '#659CD5'
          },
        }
      },
      {
        id: 500,
        name: 'Agrotóxico',
        url: 'https://produtos.simepar.br/geosimepar/forecastdev/wms?',
        url_params: {
          LAYERS: 'forecastdev:agrotoxicos_custom',
          STYLES: 'forecastdev:agrotoxicos_pastagem',
          TRANSPARENT: true,
          SRS: 'EPSG:4326',
        },
        layer_class: 'ol.layer.Tile',
        layer_type: 'ol.source.TileWMS',
        property_params: {
          opacity: 1.0,
          visible: false,
          zindex: 0,
        },
        icon_params: {
          class: '$toxic',
          background_color: '#ec5658',
        },
        tooltip_params: {
          KEYS: [
            '{"key": "locationname", "label": "SIA", "icon_label": "circle"}',
            '{"key": "pastagem_ton", "label": "Pastagem", "icon_label": "circle"}',
            '{"key": "agric_anual_ton", "label": "Agricultura", "icon_label": "circle"}',
            '{"key": "silvicultura_ton", "label": "Silvicultura", "icon_label": "circle"}',
          ],
          FORMAT:
            'SIA: {0}<br>Pastagem: {1}<br>Agricultura: {2}<br>Silvicultura: {3}',
        },
        has_submenu: true,
        caption_html: {
          alwaysVisible: false,
          vertical: false,
          custom: true,
          unit: "t/ano",
          groupItems: [
            {
              items: [{ text: '0,0 - 5', color: '#DAFFDC', style: 'circle' }],
            },
            {
              items: [{ text: '6 - 15', color: '#B6EEB9', style: 'circle' }],
            },
            {
              items: [{ text: '16 - 25', color: '#8CD390', style: 'circle' }],
            },
            {
              items: [{ text: '26 - 35', color: '#77E97C', style: 'circle' }],
            },
            {
              items: [{ text: '36 - 45', color: '#4AC54F', style: 'circle' }],
            },
            {
              items: [{ text: ' > 45', color: '#297D2C', style: 'circle' }],
            },
          ],
        },
      },
      {
        id: 501,
        name: 'Agrotóxico',
        url: 'https://produtos.simepar.br/geosimepar/forecastdev/wms?',
        url_params: {
          LAYERS: 'forecastdev:agrotoxicos_custom',
          STYLES: 'forecastdev:agrotoxicos_agricultura',
          TRANSPARENT: true,
          SRS: 'EPSG:4326',
        },
        layer_class: 'ol.layer.Tile',
        layer_type: 'ol.source.TileWMS',
        property_params: {
          opacity: 1.0,
          visible: false,
          zindex: 0,
        },
        icon_params: {
          class: '$toxic',
          background_color: '#ec5658',
        },
        tooltip_params: {
          KEYS: [
            '{"key": "locationname", "label": "SIA", "icon_label": "circle"}',
            '{"key": "pastagem_ton", "label": "Pastagem", "icon_label": "circle"}',
            '{"key": "agric_anual_ton", "label": "Agricultura", "icon_label": "circle"}',
            '{"key": "silvicultura_ton", "label": "Silvicultura", "icon_label": "circle"}',
          ],
          FORMAT:
            'SIA: {0}<br>Pastagem: {1}<br>Agricultura: {2}<br>Silvicultura: {3}',
        },
        hide_on_menu: true,
        has_submenu: true,
        caption_html: {
          alwaysVisible: false,
          vertical: false,
          custom: true,
          unit: "t/ano",
          groupItems: [
            {
              items: [{ text: '0,0 - 44', color: '#DAFFDC', style: 'circle' }],
            },
            {
              items: [{ text: '45 - 200', color: '#B6EEB9', style: 'circle' }],
            },
            {
              items: [{ text: '201 - 470', color: '#8CD390', style: 'circle' }],
            },
            {
              items: [{ text: '471 - 2300', color: '#77E97C', style: 'circle' }],
            },
            {
              items: [{ text: '2301 - 4000', color: '#4AC54F', style: 'circle' }],
            },
            {
              items: [{ text: ' > 4000', color: '#297D2C', style: 'circle' }],
            },
          ],
        },
      },
      {
        id: 502,
        name: 'Agrotóxico',
        url: 'https://produtos.simepar.br/geosimepar/forecastdev/wms?',
        url_params: {
          LAYERS: 'forecastdev:agrotoxicos_custom',
          STYLES: 'forecastdev:agrotoxicos_silvicultura',
          TRANSPARENT: true,
          SRS: 'EPSG:4326',
        },
        layer_class: 'ol.layer.Tile',
        layer_type: 'ol.source.TileWMS',
        property_params: {
          opacity: 1.0,
          visible: false,
          zindex: 0,
        },
        icon_params: {
          class: '$toxic',
          background_color: '#ec5658',
        },
        tooltip_params: {
          KEYS: [
            '{"key": "locationname", "label": "SIA", "icon_label": "circle"}',
            '{"key": "pastagem_ton", "label": "Pastagem", "icon_label": "circle"}',
            '{"key": "agric_anual_ton", "label": "Agricultura", "icon_label": "circle"}',
            '{"key": "silvicultura_ton", "label": "Silvicultura", "icon_label": "circle"}',
          ],
          FORMAT:
            'SIA: {0}<br>Pastagem: {1}<br>Agricultura: {2}<br>Silvicultura: {3}',
        },
        hide_on_menu: true,
        has_submenu: true,
        caption_html: {
          alwaysVisible: false,
          vertical: false,
          custom: true,
          unit: "t/ano",
          groupItems: [
            {
              items: [{ text: '0,0 - 0,021', color: '#DAFFDC', style: 'circle' }],
            },
            {
              items: [{ text: '0,022 - 0,11', color: '#B6EEB9', style: 'circle' }],
            },
            {
              items: [{ text: '0,12 - 0,47', color: '#8CD390', style: 'circle' }],
            },
            {
              items: [{ text: '0,48 - 0,84', color: '#77E97C', style: 'circle' }],
            },
            {
              items: [{ text: '0,85 - 2,0', color: '#4AC54F', style: 'circle' }],
            },
            {
              items: [{ text: ' > 2,0', color: '#297D2C', style: 'circle' }],
            },
          ],
        },
      },

      {
        id: 735,
        name: 'Erosão',
        url: 'https://produtos.simepar.br/geoserver/cog/wms?',
        url_params: {
          LAYERS: 'cog:erodibilidade',
          SRS: 'EPSG:4326',
        },
        layer_class: 'ol.layer.Tile',
        layer_type: 'ol.source.TileWMS',
        property_params: {
          opacity: 1.0,
          visible: false,
          zindex: 0,
        },

        icon_params: {
          class: '$erosionMenu',
          background_color: '#2F80ED',
        },
        has_submenu: true,
        caption_html: {
          alwaysVisible: false,
          vertical: false,
          custom: true,
          groupItems: [
            {
              items: [
                { text: 'Área Urbana', color: '#8792d5', style: 'circle' },
                { text: 'Alta', color: '#613D1E', style: 'circle' },
              ],
            },
            {
              items: [
                { text: 'Muito Baixa', color: '#F1DD5D', style: 'circle' },
                { text: 'Muito Alta', color: '#591602', style: 'circle' },
              ],
            },
            {
              items: [
                { text: 'Baixa', color: '#9A853E', style: 'circle' },
                { text: 'Sem dados', color: '#E0E0E0', style: 'circle' },
              ],
            },
            {
              items: [{ text: 'Média', color: '#AC8641', style: 'circle' }],
            },
          ],
        },
      },
      {
        id: 736,
        name: 'Erosão',
        url: 'https://produtos.simepar.br/geoserver/sanepar/wms?',
        url_params: {
          LAYERS: 'sanepar:susceptibilidade',
          SRS: 'EPSG:4326',
        },
        layer_class: 'ol.layer.Tile',
        layer_type: 'ol.source.TileWMS',
        property_params: {
          opacity: 1.0,
          visible: false,
          zindex: 0,
        },

        icon_params: {
          class: '$erosionMenu',
          background_color: '#2F80ED',
        },
        hide_on_menu: true,
        has_submenu: true,
        caption_html: {
          alwaysVisible: false,
          vertical: false,
          custom: true,
          groupItems: [
            {
              items: [
                { text: 'Área Urbana', color: '#8792d5', style: 'circle' },
                { text: 'Alta', color: '#613D1E', style: 'circle' },
              ],
            },
            {
              items: [
                { text: 'Muito Baixa', color: '#F1DD5D', style: 'circle' },
                { text: 'Muito Alta', color: '#591602', style: 'circle' },
              ],
            },
            {
              items: [
                { text: 'Baixa', color: '#9A853E', style: 'circle' },
                { text: 'Sem dados', color: '#E0E0E0', style: 'circle' },
              ],
            },

            {
              items: [{ text: 'Média', color: '#AC8641', style: 'circle' }],
            },
          ],
        },
      },
      {
        id: 737,
        name: 'Erosão',
        url: 'https://produtos.simepar.br/geoserver/sanepar/wms?',
        url_params: {
          LAYERS: 'sanepar:vulnerabilidade',
          SRS: 'EPSG:4326',
        },
        layer_class: 'ol.layer.Tile',
        layer_type: 'ol.source.TileWMS',
        property_params: {
          opacity: 1.0,
          visible: false,
          zindex: 0,
        },

        icon_params: {
          class: '$erosionMenu',
          background_color: '#2F80ED',
        },
        hide_on_menu: true,
        has_submenu: true,

        caption_html: {
          alwaysVisible: false,
          vertical: false,
          custom: true,
          groupItems: [
            {
              items: [
                { text: 'Área Urbana', color: '#8792d5', style: 'circle' },
                { text: 'Alta', color: '#613D1E', style: 'circle' },
              ],
            },
            {
              items: [
                { text: 'Muito Baixa', color: '#F1DD5D', style: 'circle' },
                { text: 'Muito Alta', color: '#591602', style: 'circle' },
              ],
            },
            {
              items: [
                { text: 'Baixa', color: '#9A853E', style: 'circle' },
                { text: 'Sem dados', color: '#E0E0E0', style: 'circle' },
              ],
            },

            {
              items: [{ text: 'Média', color: '#AC8641', style: 'circle' }],
            },
          ],
        },
      },

      {
        id: 503,
        name: 'Cargas Difusas',
        // http://produtos.simepar.br/geosimepar/forecastdev/wms?service=WMS&version=1.1.0&request=GetMap&layers=forecastdev:cargas&styles=forecastdev:cargas_dbo&bbox=-54.5210850253399,-26.8541950420849,-48.2927460318147,-23.0066438469853&width=768&height=474&srs=EPSG:4326&format=application/openlayers
        url: 'https://produtos.simepar.br/geosimepar/forecastdev/wms?',
        url_params: {
          LAYERS: 'forecastdev:cargas',
          STYLES: 'forecastdev:cargas_dbo',
          TRANSPARENT: true,
          SRS: 'EPSG:4326',
        },
        layer_class: 'ol.layer.Tile',
        layer_type: 'ol.source.TileWMS',
        property_params: {
          opacity: 1.0,
          visible: false,
          zindex: 0,
        },
        icon_params: {
          class: 'sort',
          background_color: '#9E9E9E',
        },
        tooltip_params: {
          KEYS: [
            '{"key": "locationname", "label": "SIA", "icon_label": "circle"}',
            '{"key": "dbo_dia", "label": "Carga DBO", "icon_label": "circle"}',
          ],
          FORMAT: 'SIA:{0} <br>Carga DBO: {1}',
        },
        has_submenu: true,
        caption_html: {
          alwaysVisible: false,
          vertical: false,
          custom: true,
          unit: "kg/dia",
          groupItems: [
            {
              items: [{ text: '0 - 1000', color: '#FFE6C6', style: 'circle' }],
            },
            {
              items: [{ text: '1000 - 2000', color: '#FFCC89', style: 'circle' }],
            },
            {
              items: [{ text: '2000 - 5000', color: '#FFBA60', style: 'circle' }],
            },
            {
              items: [{ text: '5000- 15000', color: '#C9934D', style: 'circle' }],
            },
            {
              items: [{ text: '> 15000', color: '#99703A', style: 'circle' }],
            },
          ],
        },
      },
      {
        id: 504,
        name: 'Cargas Difusas',
        // http://produtos.simepar.br/geosimepar/forecastdev/wms?service=WMS&version=1.1.0&request=GetMap&layers=forecastdev:cargas&styles=forecastdev:cargas_nt&bbox=-54.5210850253399,-26.8541950420849,-48.2927460318147,-23.0066438469853&width=768&height=474&srs=EPSG:4326&format=application/openlayers
        url: 'https://produtos.simepar.br/geosimepar/forecastdev/wms?',
        url_params: {
          LAYERS: 'forecastdev:cargas',
          STYLES: 'forecastdev:cargas_nt',
          TRANSPARENT: true,
          SRS: 'EPSG:4326',
        },
        layer_class: 'ol.layer.Tile',
        layer_type: 'ol.source.TileWMS',
        property_params: {
          opacity: 1.0,
          visible: false,
          zindex: 0,
        },
        icon_params: {
          class: 'sort',
          background_color: '#9E9E9E',
        },
        tooltip_params: {
          KEYS: [
            '{"key": "locationname", "label": "SIA", "icon_label": "circle"}',
            '{"key": "nt_dia", "label": "Carga NT", "icon_label": "circle"}',
          ],
          FORMAT: 'SIA:{0} <br>Carga NT: {1}',
        },
        hide_on_menu: true,
        has_submenu: true,
        caption_html: {
          alwaysVisible: false,
          vertical: false,
          custom: true,
          unit: "kg/dia",
          groupItems: [
            {
              items: [{ text: '0 - 500', color: '#C9BEFF', style: 'circle' }],
            },
            {
              items: [{ text: '500 - 1000', color: '#A08DFF', style: 'circle' }],
            },
            {
              items: [{ text: '1000 - 2000', color: '#7C6AD8', style: 'circle' }],
            },
            {
              items: [{ text: '2000 - 4000', color: '#6B5CB7', style: 'circle' }],
            },
            {
              items: [{ text: '> 4000', color: '#4C4184', style: 'circle' }],
            },
          ],
        },
      },
      {
        id: 505,
        name: 'Cargas Difusas',
        // http://produtos.simepar.br/geosimepar/forecastdev/wms?service=WMS&version=1.1.0&request=GetMap&layers=forecastdev:cargas&styles=forecastdev:cargas_pt&bbox=-54.5210850253399,-26.8541950420849,-48.2927460318147,-23.0066438469853&width=768&height=474&srs=EPSG:4326&format=application/openlayers
        url: 'https://produtos.simepar.br/geosimepar/forecastdev/wms?',
        url_params: {
          LAYERS: 'forecastdev:cargas',
          STYLES: 'forecastdev:cargas_pt',
          TRANSPARENT: true,
          SRS: 'EPSG:4326',
        },
        layer_class: 'ol.layer.Tile',
        layer_type: 'ol.source.TileWMS',
        property_params: {
          opacity: 1.0,
          visible: false,
          zindex: 0,
        },
        icon_params: {
          class: 'sort',
          background_color: '#9E9E9E',
        },
        tooltip_params: {
          KEYS: [
            '{"key": "locationname", "label": "SIA", "icon_label": "circle"}',
            '{"key": "pt_dia", "label": "Carga PT", "icon_label": "circle"}',
          ],
          FORMAT: 'SIA:{0} <br>Carga PT: {1}',
        },
        hide_on_menu: true,
        has_submenu: true,
        caption_html: {
          alwaysVisible: false,
          vertical: false,
          custom: true,
          unit: "kg/dia",
          groupItems: [
            {
              items: [{ text: '0 - 50', color: '#A9FFB7', style: 'circle' }],
            },
            {
              items: [{ text: '50 - 100', color: '#6CF181', style: 'circle' }],
            },
            {
              items: [{ text: '100 - 300', color: '#65C174', style: 'circle' }],
            },
            {
              items: [{ text: '300 - 500', color: '#518C5B', style: 'circle' }],
            },
            {
              items: [{ text: '> 500', color: '#3E6543', style: 'circle' }],
            },
          ],
        },
      },

      {
        //http://geoservercog01.simeparnet:8080/geoserver/tiff/wms?service=WMS&version=1.1.0&request=GetMap&layers=tiff%3Ausodosolo_2021&bbox=-54.619440356487246%2C-26.854271904020646%2C-48.02368977266139%2C-22.517141892884013&width=768&height=505&srs=EPSG%3A4326&styles=&format=application/openlayers
        id: 750,
        name: 'Bovinos',
        url: 'https://produtos.simepar.br/geosimepar/forecastdev/wms?',
        url_params: {
          LAYERS: 'forecastdev:bovinos',
          TRANSPARENT: true,
          SRS: 'EPSG:4326',
          Format: 'image/png',
        },
        layer_class: 'ol.layer.Tile',
        layer_type: 'ol.source.TileWMS',
        property_params: {
          opacity: 1.0,
          visible: false,
          zindex: 0,
        },
        icon_params: {
          class: '$bovinesMap',
          background_color: '#F2994A',
        },
        tooltip_params: {
          KEYS: ['{"key": "totalbov", "label": "total"}'],
        },
        caption_html: {
          alwaysVisible: false,
          vertical: false,
          custom: true,
          groupItems: [
            {
              items: [
                { text: '0 - 42.000', color: '#FDFD8A', style: 'circle' },
                {
                  text: '170.000 - 210.000',
                  color: '#B7843D',
                  style: 'circle',
                },
              ],
            },
            {
              items: [
                { text: '42.000 - 84.000', color: '#F4E477', style: 'circle' },
                {
                  text: '210.000 - 250.000',
                  color: '#925C30',
                  style: 'circle',
                },
              ],
            },
            {
              items: [
                { text: '84.000 - 127.000', color: '#E7CC64', style: 'circle' },

                {
                  text: '250.000 - 300.000',
                  color: '#6E3327',
                  style: 'circle',
                },
              ],
            },
            {
              items: [
                {
                  text: '127.000 - 170.000',
                  color: '#E0B74C',
                  style: 'circle',
                },
              ],
            },
          ],
        },
      },

      {
        id: 400,
        name: 'Restrições Ambientais',
        url: 'https://produtos.simepar.br/geobarragem/gif/wms?',
        url_params: {
          LAYERS: 'gif:restr_amb',
          TRANSPARENT: true,
          SRS: 'EPSG:4326',
          Format: 'image/png',
        },
        layer_class: 'ol.layer.Tile',
        layer_type: 'ol.source.TileWMS',
        property_params: {
          opacity: 0.9,
          visible: false,
          zindex: 0,
        },
        icon_params: {
          class: '$restrictions',
          background_color: '#BB6BD9',
        },
        caption_html: {
          alwaysVisible: false,
          vertical: false,
          custom: true,
          groupItems: [
            {
              items: [{ text: '0', color: '#DEDEDB', style: 'circle' }],
            },
            {
              items: [{ text: '1', color: '#008000', style: 'circle' }],
            },
            {
              items: [{ text: '2', color: '#4AC54F', style: 'circle' }],
            },
            {
              items: [{ text: '3', color: '#F2C94C', style: 'circle' }],
            },
            {
              items: [{ text: '4', color: '#F2994A', style: 'circle' }],
            },
            {
              items: [{ text: '5', color: '#EB5757', style: 'circle' }],
            },
          ],
        },
      },

      {
        id: 401,
        url: 'https://produtos.simepar.br/geobarragem/shape/wms?',
        url_params: {
          LAYERS: 'shape:areas_prioritarias',
          TRANSPARENT: true,
          SRS: 'EPSG:4326',
          Format: 'image/png',
          STYLES: 'pgw-polygon_env',
          env: "fill_color:C07246;fill_opacity:0.9;stroke_color:C07246",
        },
        layer_class: 'ol.layer.Tile',
        layer_type: 'ol.source.TileWMS',
        property_params: {
          opacity: 1.0,
          visible: false,
          zindex: 0,
        },
        // icon_params: {
        //   class: '$restrictions',
        //   background_color: '#BB6BD9',
        // },
        hide_on_menu: true,
        caption_html: {
          alwaysVisible: false,
          vertical: false,
          custom: true,
          groupItems: [
            {
              items: [
                { text: 'Áreas Prioritárias para Conservação da Biodiversidade', color: '#C07246', style: 'circle' },
              ],
            },
          ],
        },
      },

      {
        id: 402,
        url: 'https://produtos.simepar.br/geobarragem/bd/wms?',
        url_params: {
          LAYERS: 'bd:assentamento',
          TRANSPARENT: true,
          SRS: 'EPSG:4326',
          Format: 'image/png',
          STYLES: 'pgw-polygon_env',
          env: "fill_color:660A0A;fill_opacity:0.8;stroke_color:660A0A"
        },
        layer_class: 'ol.layer.Tile',
        layer_type: 'ol.source.TileWMS',
        property_params: {
          opacity: 1.0,
          visible: false,
          zindex: 0,
        },
        // icon_params: {
        //   class: '$restrictions',
        //   background_color: '#BB6BD9',
        // },
        hide_on_menu: true,
        caption_html: {
          alwaysVisible: false,
          vertical: false,
          custom: true,
          groupItems: [
            {
              items: [
                { text: 'Assentamentos', color: '#660A0A', style: 'circle' },
              ],
            },
          ],
        },
      },

      {
        id: 403,
        url: 'https://produtos.simepar.br/geosimepar/tiff/wms?',
        url_params: {
          LAYERS: 'tiff:topologiapr',
          TRANSPARENT: true,
          SRS: 'EPSG:4326',
          Format: 'image/png',
        },
        layer_class: 'ol.layer.Tile',
        layer_type: 'ol.source.TileWMS',
        property_params: {
          opacity: 1.0,
          visible: false,
          zindex: 0,
        },
        // icon_params: {
        //   class: '$restrictions',
        //   background_color: '#BB6BD9',
        // },
        hide_on_menu: true,
        caption_html: {
          alwaysVisible: false,
          vertical: false,
          custom: true,
          groupItems: [
            {
              items: [
                { text: 'Topografia ', color: '#64401F', style: 'circle' },
              ],
            },
          ],
        },
      },

      {
        id: 404,
        url: 'https://produtos.simepar.br/geosimepar/shape/wms?',
        url_params: {
          LAYERS: 'shape:terras_indigenas',
          TRANSPARENT: true,
          SRS: 'EPSG:4326',
          Format: 'image/png',
          STYLES: "pgw_polygon_env",
          env: "fill_color:F3859F;fill_opacity:0.9;stroke_color:F3859F"
        },
        layer_class: 'ol.layer.Tile',
        layer_type: 'ol.source.TileWMS',
        property_params: {
          opacity: 1.0,
          visible: false,
          zindex: 0,
        },
        // icon_params: {
        //   class: '$restrictions',
        //   background_color: '#BB6BD9',
        // },
        hide_on_menu: true,
        caption_html: {
          alwaysVisible: false,
          vertical: false,
          custom: true,
          groupItems: [
            {
              items: [
                { text: 'Terras Indígenas ', color: '#F3859F', style: 'circle' },
              ],
            },
          ],
        },
      },

      {
        id: 405,
        url: 'https://produtos.simepar.br/geosimepar/sanepar/wms?',
        url_params: {
          LAYERS: 'sanepar:ucs',
          TRANSPARENT: true,
          SRS: 'EPSG:4326',
          Format: 'image/png',
          STYLES: "pgw_polygon_env",
          env: "fill_color:CF4F57;fill_opacity:0.9;stroke_color:CF4F57"
        },
        layer_class: 'ol.layer.Tile',
        layer_type: 'ol.source.TileWMS',
        property_params: {
          opacity: 1.0,
          visible: false,
          zindex: 0,
        },
        // icon_params: {
        //   class: '$restrictions',
        //   background_color: '#BB6BD9',
        // },
        hide_on_menu: true,
        caption_html: {
          alwaysVisible: false,
          vertical: false,
          custom: true,
          groupItems: [
            {
              items: [
                { text: 'Unidades de Conservação', color: '#CF4F57', style: 'circle' },
              ],
            },
          ],
        },
      },

      {
        id: 406,
        url: 'https://produtos.simepar.br/geobarragem/bd/wms?',
        url_params: {
          LAYERS: 'bd:apa',
          TRANSPARENT: true,
          SRS: 'EPSG:4326',
          Format: 'image/png',
          STYLES: "pgw-polygon_env",
          env: "fill_color:8330FF;fill_opacity:0.8;stroke_color:8330FF"
        },
        layer_class: 'ol.layer.Tile',
        layer_type: 'ol.source.TileWMS',
        property_params: {
          opacity: 1.0,
          visible: false,
          zindex: 0,
        },
        // icon_params: {
        //   class: '$restrictions',
        //   background_color: '#BB6BD9',
        // },
        hide_on_menu: true,
        caption_html: {
          alwaysVisible: false,
          vertical: false,
          custom: true,
          groupItems: [
            {
              items: [
                { text: 'Áreas de Preservação Ambiental', color: '#8330FF', style: 'circle' },
              ],
            },
          ],
        },
      },

      {
        id: 407,
        url: 'https://produtos.simepar.br/geosimepar/sanepar/wms?',
        url_params: {
          LAYERS: 'sanepar:RPPN_Estaduais_SIGAS2000_NIGI_IAT_2022_PR_WGS84',
          TRANSPARENT: true,
          SRS: 'EPSG:4326',
          Format: 'image/png',
          STYLES: "pgw_polygon_env",
          env: "fill_color:545E85;fill_opacity:0.9;stroke_color:545E85"
        },
        layer_class: 'ol.layer.Tile',
        layer_type: 'ol.source.TileWMS',
        property_params: {
          opacity: 1.0,
          visible: false,
          zindex: 0,
        },
        // icon_params: {
        //   class: '$restrictions',
        //   background_color: '#BB6BD9',
        // },
        hide_on_menu: true,
        caption_html: {
          alwaysVisible: false,
          vertical: false,
          custom: true,
          groupItems: [
            {
              items: [
                { text: 'Reservas Particulares do Patrimônio Natural', color: '#2D3D51', style: 'circle' },
              ],
            },
          ],
        },
      },

      {
        id: 408,
        url: 'https://produtos.simepar.br/geobarragem/shape/wms?',
        url_params: {
          LAYERS: 'shape:sitio_arqueologico',
          TRANSPARENT: true,
          SRS: 'EPSG:4326',
          Format: 'image/png',
          STYLES: "point_env",
          env: "fill_color:9A539B;fill_opacity:0.8;stroke_color:9A539B"
        },
        layer_class: 'ol.layer.Tile',
        layer_type: 'ol.source.TileWMS',
        property_params: {
          opacity: 1.0,
          visible: false,
          zindex: 0,
        },
        // icon_params: {
        //   class: '$restrictions',
        //   background_color: '#BB6BD9',
        // },
        hide_on_menu: true,
        caption_html: {
          alwaysVisible: false,
          vertical: false,
          custom: true,
          groupItems: [
            {
              items: [
                { text: 'Sítios Arqueológicos (IPHAN)', color: '#9A539B', style: 'circle' },
              ],
            },
          ],
        },
      },
    ],
  },

  {
    "type": "satellite_grouping_player",
    "name": "Imagens de satélites dos reservatórios",
    "visible": true,
    "layers": [
      {
        "id": 4750,
        "name": "Iraí - MACR S1",
        "url": "https://produtos.simepar.br/geosimepar/monitoramento/wms?",
        "url_params": {
          "LAYERS": "monitoramento:irai",
          "TRANSPARENT": true,
          "SRS": "EPSG:4326",
          "DIM_VAR": "macr",
          "DIM_indsat": "S1",
          "BBOX": [
            -49.1309482154984,
            -25.4308669056158,
            -49.0690244017403,
            -25.3741343464687
          ]
        },
        "layer_class": "ol.layer.Image",
        "layer_type": "ol.source.ImageWMS",
        "property_params": {
          "opacity": 0.8,
          "visible": false,
          "zindex": 0
        },
        "animation_type": "IMAGE_MOSAIC",
        "params": {
          "IMAGE_MOSAIC": {
            "SERVER": "geosimepar",
            "URL_GEOJSON": "https://produtos.simepar.br/geosimepar/monitoramento/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=monitoramento:dbirai&outputFormat=application%2Fjson&sortBy=time+D&cql_filter=var=%27macr%27%20and%20indsat=%27S1%27",
            "FEATURE_INFO_VALUE": "irai",
            "TITLE_DATETIME_FORMAT": "DD/MM/YYYY",
            "TIME_FEATURE_PROPERTY": "time"
          }
        }
      },
      {
        "id": 4751,
        "name": "Iraí - NDCI S2",
        "url": "https://produtos.simepar.br/geosimepar/monitoramento/wms?",
        "url_params": {
          "LAYERS": "monitoramento:irai",
          "TRANSPARENT": true,
          "SRS": "EPSG:4326",
          "DIM_VAR": "ndci",
          "DIM_indsat": "S2",
          "BBOX": [
            -49.13085224855388,
            -25.43080739662154,
            -49.06906314352265,
            -25.374151504907815
          ]
        },
        "layer_class": "ol.layer.Image",
        "layer_type": "ol.source.ImageWMS",
        "property_params": {
          "opacity": 0.8,
          "visible": false,
          "zindex": 0
        },
        "animation_type": "IMAGE_MOSAIC",
        "params": {
          "IMAGE_MOSAIC": {
            "SERVER": "geosimepar",
            "URL_GEOJSON": "https://produtos.simepar.br/geosimepar/monitoramento/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=monitoramento:dbirai&outputFormat=application%2Fjson&sortBy=time+D&cql_filter=var=%27ndci%27%20and%20indsat=%27S2%27",
            "FEATURE_INFO_VALUE": "irai",
            "TITLE_DATETIME_FORMAT": "DD/MM/YYYY",
            "TIME_FEATURE_PROPERTY": "time"
          }
        }
      },
      {
        "id": 4753,
        "name": "Iraí - NDTI S2",
        "url": "https://produtos.simepar.br/geosimepar/monitoramento/wms?",
        "url_params": {
          "LAYERS": "monitoramento:irai",
          "TRANSPARENT": true,
          "SRS": "EPSG:4326",
          "DIM_VAR": "ndti",
          "DIM_indsat": "S2",
          "BBOX": [
            -49.13085224855388,
            -25.43080739662154,
            -49.06906314352265,
            -25.374151504907815
          ]
        },
        "layer_class": "ol.layer.Image",
        "layer_type": "ol.source.ImageWMS",
        "property_params": {
          "opacity": 0.8,
          "visible": false,
          "zindex": 0
        },
        "animation_type": "IMAGE_MOSAIC",
        "params": {
          "IMAGE_MOSAIC": {
            "SERVER": "geosimepar",
            "URL_GEOJSON": "https://produtos.simepar.br/geosimepar/monitoramento/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=monitoramento:dbirai&outputFormat=application%2Fjson&sortBy=time+D&cql_filter=var=%27ndti%27%20and%20indsat=%27S2%27",
            "FEATURE_INFO_VALUE": "irai",
            "TITLE_DATETIME_FORMAT": "DD/MM/YYYY",
            "TIME_FEATURE_PROPERTY": "time"
          }
        }
      },
      {
        "id": 4754,
        "name": "Passaúna - MACR S1",
        "url": "https://produtos.simepar.br/geosimepar/monitoramento/wms?",
        "url_params": {
          "LAYERS": "monitoramento:passauna",
          "TRANSPARENT": true,
          "SRS": "EPSG:4326",
          "DIM_VAR": "macr",
          "DIM_indsat": "S1",
          "BBOX": [
            -49.43661184183909,
            -25.55129154289476,
            -49.3183196857103,
            -25.42867990819883
          ]
        },
        "layer_class": "ol.layer.Image",
        "layer_type": "ol.source.ImageWMS",
        "property_params": {
          "opacity": 0.8,
          "visible": false,
          "zindex": 0
        },
        "animation_type": "IMAGE_MOSAIC",
        "params": {
          "IMAGE_MOSAIC": {
            "SERVER": "geosimepar",
            "URL_GEOJSON": "https://produtos.simepar.br/geosimepar/monitoramento/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=monitoramento:dbpassauna&outputFormat=application%2Fjson&sortBy=time+D&cql_filter=var=%27macr%27%20and%20indsat=%27S1%27",
            "FEATURE_INFO_VALUE": "passauna",
            "TITLE_DATETIME_FORMAT": "DD/MM/YYYY",
            "TIME_FEATURE_PROPERTY": "time"
          }
        }
      },
      {
        "id": 4756,
        "name": "Passaúna - NDCI S2",
        "url": "https://produtos.simepar.br/geosimepar/monitoramento/wms?",
        "url_params": {
          "LAYERS": "monitoramento:passauna",
          "TRANSPARENT": true,
          "SRS": "EPSG:4326",
          "DIM_VAR": "ndci",
          "DIM_indsat": "S2",
          "BBOX": [
            -49.43661184183909,
            -25.55129154289476,
            -49.3183196857103,
            -25.42867990819883
          ]
        },
        "layer_class": "ol.layer.Image",
        "layer_type": "ol.source.ImageWMS",
        "property_params": {
          "opacity": 0.8,
          "visible": false,
          "zindex": 0
        },
        "animation_type": "IMAGE_MOSAIC",
        "params": {
          "IMAGE_MOSAIC": {
            "SERVER": "geosimepar",
            "URL_GEOJSON": "https://produtos.simepar.br/geosimepar/monitoramento/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=monitoramento:dbpassauna&outputFormat=application%2Fjson&sortBy=time+D&cql_filter=var=%27ndci%27%20and%20indsat=%27S2%27",
            "FEATURE_INFO_VALUE": "passauna",
            "TITLE_DATETIME_FORMAT": "DD/MM/YYYY",
            "TIME_FEATURE_PROPERTY": "time"
          }
        }
      },
      {
        "id": 4757,
        "name": "Passaúna - NDTI S2",
        "url": "https://produtos.simepar.br/geosimepar/monitoramento/wms?",
        "url_params": {
          "LAYERS": "monitoramento:passauna",
          "TRANSPARENT": true,
          "SRS": "EPSG:4326",
          "DIM_VAR": "ndti",
          "DIM_indsat": "S2",
          "BBOX": [
            -49.43661184183909,
            -25.55129154289476,
            -49.3183196857103,
            -25.42867990819883
          ]
        },
        "layer_class": "ol.layer.Image",
        "layer_type": "ol.source.ImageWMS",
        "property_params": {
          "opacity": 0.8,
          "visible": false,
          "zindex": 0
        },
        "animation_type": "IMAGE_MOSAIC",
        "params": {
          "IMAGE_MOSAIC": {
            "SERVER": "geosimepar",
            "URL_GEOJSON": "https://produtos.simepar.br/geosimepar/monitoramento/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=monitoramento:dbpassauna&outputFormat=application%2Fjson&sortBy=time+D&cql_filter=var=%27ndti%27%20and%20indsat=%27S2%27",
            "FEATURE_INFO_VALUE": "passauna",
            "TITLE_DATETIME_FORMAT": "DD/MM/YYYY",
            "TIME_FEATURE_PROPERTY": "time"
          }
        }
      },
      {
        "id": 4758,
        "name": "Piraquara I e II - MACR S1",
        "url": "https://produtos.simepar.br/geosimepar/monitoramento/wms?",
        "url_params": {
          "LAYERS": "monitoramento:piraquaras",
          "TRANSPARENT": true,
          "SRS": "EPSG:4326",
          "DIM_VAR": "macr",
          "DIM_indsat": "S1",
          "BBOX": [
            -49.10201557983834,
            -25.551750726485974,
            -48.96783512001199,
            -25.425252149499855
          ]
        },
        "layer_class": "ol.layer.Image",
        "layer_type": "ol.source.ImageWMS",
        "property_params": {
          "opacity": 0.8,
          "visible": false,
          "zindex": 0
        },
        "animation_type": "IMAGE_MOSAIC",
        "params": {
          "IMAGE_MOSAIC": {
            "SERVER": "geosimepar",
            "URL_GEOJSON": "https://produtos.simepar.br/geosimepar/monitoramento/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=monitoramento:dbpiraquaras&outputFormat=application%2Fjson&sortBy=time+D&cql_filter=var=%27macr%27%20and%20indsat=%27S1%27",
            "FEATURE_INFO_VALUE": "piraquaras",
            "TITLE_DATETIME_FORMAT": "DD/MM/YYYY",
            "TIME_FEATURE_PROPERTY": "time"
          }
        }
      },
      {
        "id": 4760,
        "name": "Piraquara I e II - NDCI S2",
        "url": "https://produtos.simepar.br/geosimepar/monitoramento/wms?",
        "url_params": {
          "LAYERS": "monitoramento:piraquaras",
          "TRANSPARENT": true,
          "SRS": "EPSG:4326",
          "DIM_VAR": "ndci",
          "DIM_indsat": "S2",
          "BBOX": [
            -49.10201557983834,
            -25.551750726485974,
            -48.96783512001199,
            -25.425252149499855
          ]
        },
        "layer_class": "ol.layer.Image",
        "layer_type": "ol.source.ImageWMS",
        "property_params": {
          "opacity": 0.8,
          "visible": false,
          "zindex": 0
        },
        "animation_type": "IMAGE_MOSAIC",
        "params": {
          "IMAGE_MOSAIC": {
            "SERVER": "geosimepar",
            "URL_GEOJSON": "https://produtos.simepar.br/geosimepar/monitoramento/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=monitoramento:dbpiraquaras&outputFormat=application%2Fjson&sortBy=time+D&cql_filter=var=%27ndci%27%20and%20indsat=%27S2%27",
            "FEATURE_INFO_VALUE": "piraquaras",
            "TITLE_DATETIME_FORMAT": "DD/MM/YYYY",
            "TIME_FEATURE_PROPERTY": "time"
          }
        }
      },
      {
        "id": 4761,
        "name": "Piraquara I e II - NDTI S2",
        "url": "https://produtos.simepar.br/geosimepar/monitoramento/wms?",
        "url_params": {
          "LAYERS": "monitoramento:piraquaras",
          "TRANSPARENT": true,
          "SRS": "EPSG:4326",
          "DIM_VAR": "ndti",
          "DIM_indsat": "S2",
          "BBOX": [
            -49.10201557983834,
            -25.551750726485974,
            -48.96783512001199,
            -25.425252149499855
          ]
        },
        "layer_class": "ol.layer.Image",
        "layer_type": "ol.source.ImageWMS",
        "property_params": {
          "opacity": 0.8,
          "visible": false,
          "zindex": 0
        },
        "animation_type": "IMAGE_MOSAIC",
        "params": {
          "IMAGE_MOSAIC": {
            "SERVER": "geosimepar",
            "URL_GEOJSON": "https://produtos.simepar.br/geosimepar/monitoramento/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=monitoramento:dbpiraquaras&outputFormat=application%2Fjson&sortBy=time+D&cql_filter=var=%27ndti%27%20and%20indsat=%27S2%27",
            "FEATURE_INFO_VALUE": "piraquaras",
            "TITLE_DATETIME_FORMAT": "DD/MM/YYYY",
            "TIME_FEATURE_PROPERTY": "time"
          }
        }
      }
    ]
  },


];

export default layers;
